<template>
  <div class="articles-list">
    <div class="toolbar">
      <div class="search-box">
        <select v-model="filterCategoryId" class="filter-select" @change="handleSearch">
          <option value="0">全部分类</option>
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
        </select>
        <input
          v-model="keyword"
          type="text"
          placeholder="搜索文章标题..."
          @keyup.enter="handleSearch"
        />
        <button class="btn-search" @click="handleSearch">搜索</button>
      </div>
      <button class="btn-primary" @click="$router.push('/article/create')">+ 新建文章</button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>

    <div v-else-if="list.length === 0" class="empty">
      <p>暂无文章数据</p>
    </div>

    <div v-else class="card-list">
      <div v-for="item in list" :key="item.id" class="list-item">
        <div class="item-cover" @click="$router.push('/article/edit/' + item.id)">
          <img v-if="item.image" :src="item.image" alt="cover" />
          <span v-else class="no-cover">暂无封面</span>
        </div>
        <div class="item-body" @click="$router.push('/article/edit/' + item.id)">
          <div class="item-header">
            <span v-if="item.category_name" class="category-tag">{{ item.category_name }}</span>
            <span v-else class="no-category">未分类</span>
            <span class="item-date">{{ item.date }}</span>
          </div>
          <p class="item-main-title" v-if="item.main_title">{{ item.main_title }}</p>
          <h4 class="item-title">{{ item.title }}</h4>
          <p class="item-price" v-if="item.price">价格：{{ item.price }}</p>
          <p class="item-summary">{{ item.summary }}</p>
        </div>
        <div class="item-actions">
          <button class="btn-edit" @click="$router.push('/article/edit/' + item.id)">编辑</button>
          <button class="btn-del" @click="handleDelete(item)">删除</button>
        </div>
      </div>
    </div>

    <div v-if="total > pageSize" class="pagination">
      <button :disabled="page <= 1" @click="changePage(page - 1)">上一页</button>
      <span class="page-info">{{ page }} / {{ totalPages }}</span>
      <button :disabled="page >= totalPages" @click="changePage(page + 1)">下一页</button>
    </div>

    <div v-if="showDeleteConfirm" class="modal-overlay" @click.self="showDeleteConfirm = false">
      <div class="modal-box">
        <h3>确认删除</h3>
        <p>确定要删除文章「{{ deleteTarget ? deleteTarget.title : '' }}」吗？此操作不可恢复。</p>
        <div class="modal-actions">
          <button class="btn-cancel" @click="showDeleteConfirm = false">取消</button>
          <button class="btn-primary" @click="confirmDelete">确认删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../api/index';

export default {
  name: 'ArticlesList',
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 1000,
      keyword: '',
      filterCategoryId: 0,
      categories: [],
      loading: false,
      showDeleteConfirm: false,
      deleteTarget: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  created() {
    this.fetchCategories();
    this.fetchList();
  },
  methods: {
    async fetchCategories() {
      try {
        var res = await request('/categories.php');
        this.categories = res.data || [];
      } catch (e) { /* ignore */ }
    },
    async fetchList() {
      this.loading = true;
      try {
        var url = '/articles.php?page=' + this.page + '&pageSize=' + this.pageSize;
        if (this.keyword) url += '&keyword=' + encodeURIComponent(this.keyword);
        if (this.filterCategoryId > 0) url += '&category_id=' + this.filterCategoryId;
        const res = await request(url);
        this.list = res.data.list;
        this.total = res.data.total;
      } catch (e) {
        alert('加载失败: ' + e.message);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.fetchList();
    },
    changePage(p) {
      this.page = p;
      this.fetchList();
    },
    handleDelete(item) {
      this.deleteTarget = item;
      this.showDeleteConfirm = true;
    },
    async confirmDelete() {
      if (!this.deleteTarget) return;
      try {
        await request(`/articles.php?id=${this.deleteTarget.id}`, { method: 'DELETE' });
        this.showDeleteConfirm = false;
        this.deleteTarget = null;
        this.fetchList();
      } catch (e) {
        alert('删除失败: ' + e.message);
      }
    },
  },
};
</script>

<style scoped>
.articles-list {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-box {
  display: flex;
  gap: 8px;
  align-items: center;
}

.filter-select {
  height: 36px;
  padding: 0 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
  background: #fff;
  min-width: 110px;
}

.filter-select:focus { border-color: #1677FF; }

.search-box input {
  width: 220px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.search-box input:focus { border-color: #1677FF; }

.btn-search {
  height: 36px;
  padding: 0 16px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-search:hover { background: #4096ff; }

.btn-primary {
  height: 36px;
  padding: 0 20px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary:hover { background: #4096ff; }

.loading, .empty { text-align: center; padding: 60px 0; color: #999; }

/* Card List */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  transition: box-shadow 0.2s;
}

.list-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }

.item-cover {
  width: 56px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-cover { color: #ccc; font-size: 12px; }

.item-body {
  flex: 1;
  margin-left: 12px;
  cursor: pointer;
  min-width: 0;
}

.item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.category-tag {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 12px;
  background: #f0f5ff;
  color: #2f54eb;
  border: 1px solid #adc6ff;
}

.no-category { color: #ccc; font-size: 12px; }

.item-date { font-size: 12px; color: #bbb; }

.item-main-title {
  font-size: 12px;
  color: #1677FF;
  font-weight: 500;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-price {
  font-size: 13px;
  color: #ff6700;
  margin: 0 0 2px;
}

.item-summary {
  font-size: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.item-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 16px;
  flex-shrink: 0;
}

.btn-edit {
  padding: 5px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #555;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.btn-edit:hover { border-color: #1677FF; color: #1677FF; }

.btn-del {
  padding: 5px 16px;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  background: #fff;
  color: #ff4d4f;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.btn-del:hover { background: #ff4d4f; color: #fff; }

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.pagination button {
  padding: 6px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
}

.pagination button:hover:not(:disabled) { border-color: #1677FF; color: #1677FF; }
.pagination button:disabled { color: #ccc; cursor: not-allowed; }
.page-info { color: #666; font-size: 13px; }

/* Modal */
.modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.modal-box {
  width: 420px; background: #fff; border-radius: 8px;
  padding: 32px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);
}
.modal-box h3 { font-size: 18px; margin-bottom: 12px; }
.modal-box p { color: #666; margin-bottom: 24px; line-height: 1.6; }
.modal-actions { display: flex; justify-content: flex-end; gap: 12px; }
.btn-cancel {
  height: 36px; padding: 0 20px;
  border: 1px solid #d9d9d9; border-radius: 4px;
  background: #fff; cursor: pointer; font-size: 14px;
}
.btn-cancel:hover { border-color: #1677FF; color: #1677FF; }
</style>
